import { makeStyles } from "tss-react/mui";
import { DocumentThumbnail } from "@miplatform/components";
import { Box } from "@mui/material";

const MaterialImage = ({ item }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.imageContainer}>
      <DocumentThumbnail
        document={item.documents?.[0]}
        dimension={45}
        style={{ borderRadius: 3, border: "none" }}
      />
    </Box>
  );
};

export default MaterialImage;

const useStyles = makeStyles()((theme) => ({
  imageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
    padding: `${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(
      2
    )} ${theme.spacing(2)}`,
  },
  image: {
    width: 50,
    height: 50,
    border: "none",
  },
}));
